import { NgModule } from '@angular/core';
import { CartBaseComponentsModule } from './cart-base-components.module';
import { CartBaseOccModule } from '@spartacus/cart/base/occ';
import { CartBaseRootModule } from '@spartacus/cart/base/root';
import { CartPageEventModule, CartBaseCoreModule, CartPersistenceModule } from '@spartacus/cart/base/core';
import { SpartacusCartQuickOrderFeatureModule } from './cart-quick-order-feature.module';
import { SpartacusCartSavedCartFeatureModule } from './cart-saved-cart-feature.module';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { MiniCartModule } from '@spartacus/cart/base/components/mini-cart';

const featureModules = [
  MiniCartModule,
  CartBaseOccModule,
  CartPageEventModule,
  CartPersistenceModule,
  CartBaseComponentsModule,
  CartBaseCoreModule,
  CartBaseOccModule,
  CartBaseRootModule,
  SpartacusCartQuickOrderFeatureModule,
  SpartacusCartSavedCartFeatureModule,
];

@NgModule({
  imports: [...featureModules],
  exports: [...featureModules],
  providers: [
    provideConfig({
      featureModules: {
        cartBase: {
          module: () => import('@spartacus/cart/base/root').then((m) => m.CartBaseRootModule),
        },
      },
    } as CmsConfig),
  ],
})
export class SpartacusCartFeatureModule {}
